import { render, staticRenderFns } from "./alert-banner-minimal.vue?vue&type=template&id=30e14418&"
import script from "./alert-banner-minimal.vue?vue&type=script&lang=js&"
export * from "./alert-banner-minimal.vue?vue&type=script&lang=js&"
import style0 from "./alert-banner-minimal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports